import { z } from 'zod';
/**
 * @NOTE When updating this please update the @see ViewAutomationModal.types.ts file
 */
export var ReachMergeFieldTypeEnum;
(function (ReachMergeFieldTypeEnum) {
    ReachMergeFieldTypeEnum["STATIC"] = "static";
    ReachMergeFieldTypeEnum["DYNAMIC"] = "dynamic";
})(ReachMergeFieldTypeEnum || (ReachMergeFieldTypeEnum = {}));
const baseMergeFieldSchema = z.object({
    id: z.string().describe('The id of the merge field'),
    type: z.nativeEnum(ReachMergeFieldTypeEnum),
});
export const dynamicMergeFieldSchema = baseMergeFieldSchema.extend({
    type: z.literal(ReachMergeFieldTypeEnum.DYNAMIC),
    mergeFields: z.array(z.object({
        templateName: z
            .string()
            .describe('The template name of the merge field (e.g. black_friday_coupon)'),
        displayName: z
            .string()
            .describe('The display name of the merge field (e.g. "Black Friday Sale 50% off")'),
        image: z
            .object({
            placeholderUrl: z.string().describe('The placeholder url of the image'),
            maxSize: z.number().describe('The max size of the image in bytes'),
        })
            .optional(),
    })),
    url: z.string().describe('The url to fetch the dynamic merge fields from'),
    parameters: z
        .record(z.string(), z.any())
        .optional()
        .describe('Additional parameters for the dynamic merge field'),
});
export const staticMergeFieldSchema = baseMergeFieldSchema.extend({
    type: z.literal(ReachMergeFieldTypeEnum.STATIC),
    templateName: z.string().describe('The template name of the merge field (e.g. black_friday_coupon)'),
    displayName: z
        .string()
        .describe('The display name of the merge field (e.g. "Black Friday Sale 50% off")'),
    staticValue: z.string().describe('The static value of the merge field (e.g. "CODE123")'),
});
//# sourceMappingURL=communication-groups.js.map